import Vue from "vue";
import VueApexCharts from "vue-apexcharts";


Vue.use(VueApexCharts);

// eslint-disable-next-line vue/multi-word-component-names
Vue.component("apexchart", VueApexCharts);
